import { render, staticRenderFns } from "./LocationsSection.vue?vue&type=template&id=25bf6d89&scoped=true"
import script from "./LocationsSection.vue?vue&type=script&lang=js"
export * from "./LocationsSection.vue?vue&type=script&lang=js"
import style0 from "./LocationsSection.vue?vue&type=style&index=0&id=25bf6d89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf6d89",
  null
  
)

export default component.exports